import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useFadeIn } from '../hooks/useFadeIn';
import { ImagePlaceholder } from './ImagePlaceholder';
export function Hero() {
  const {
    ref,
    isVisible
  } = useFadeIn();
  const trustBadges = ['Cuenta Verificada', '+1.000 Sonrisas', 'Valoración Gratis', 'Tecnología Digital'];
  return <section id="inicio" className="relative min-h-screen flex items-center pt-24 overflow-hidden bg-primary" data-id="element-230">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-231">
        <img src="https://cdn.magicpatterns.com/uploads/uMRmH7BVNefbSnHfnV6Lq9/quiero_que_a_esat_foto_le_quit_Nano_Banana_2_23957.png" alt="Fachada Odontología Estética Pereira" className="absolute inset-0 w-full h-full object-cover" data-id="element-232" />
        {/* Heavy dark overlay — 0.90 left, 0.75 right */}
        <div className="absolute inset-0 z-10" style={{
        background: 'linear-gradient(to right, rgba(10,10,10,0.95) 0%, rgba(10,10,10,0.90) 50%, rgba(10,10,10,0.75) 100%)'
      }} data-id="element-233"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20 w-full py-12 lg:py-0" data-id="element-234">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-235">
          {/* Left Content */}
          <div ref={ref} className={`transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-236">
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white leading-tight mb-6" data-id="element-237">
              Recupera la Confianza <br className="hidden sm:block" data-id="element-238" />
              en Tu Sonrisa
            </h1>

            <h2 className="text-gold text-xl sm:text-2xl font-medium mb-6" data-id="element-239">
              Expertos en Diseño de Sonrisa y <br className="hidden sm:block" data-id="element-240" />
              Odontología de Alta Estética en Pereira
            </h2>

            <p className="text-white/85 text-base sm:text-lg mb-10 max-w-xl leading-relaxed" data-id="element-241">
              Transformamos tu sonrisa con tecnología de última generación y los
              mejores materiales del mercado. Tu valoración inicial es
              completamente gratis.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-242">
              <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-hover text-primary font-bold px-8 py-4 rounded-lg text-center transition-colors flex items-center justify-center gap-2" data-id="element-243">
                <span data-id="element-244">💬</span> Agenda tu Valoración GRATIS
              </a>
              <Link to="/antes-y-despues" className="bg-transparent border-2 border-gold text-gold hover:bg-gold/10 font-bold px-8 py-4 rounded-lg text-center transition-colors" data-id="element-245">
                Ver Nuestros Resultados ↓
              </Link>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-246">
              {trustBadges.map((badge, index) => <div key={index} className="flex items-center gap-2 text-sm text-gray" data-id="element-247">
                  <CheckCircle2 size={16} className="text-gold" data-id="element-248" />
                  <span data-id="element-249">{badge}</span>
                </div>)}
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative hidden lg:block h-[600px] w-full animate-float" data-id="element-250">
            <div className="absolute inset-0 border-2 border-gold/30 rounded-2xl transform translate-x-4 translate-y-4" data-id="element-251"></div>
            <img src="https://cdn.magicpatterns.com/uploads/6kYu18YAGqGkEVVUypsrB7/10.jpg" alt="Resultado de sonrisa perfecta" className="absolute inset-0 w-full h-full object-cover rounded-2xl shadow-2xl border border-border" data-id="element-252" />
          </div>
        </div>
      </div>
    </section>;
}